<template>
  <router-link class="week-list-item" tag="div" :to="url">
    <div class="flex">
      <span class="title">{{ start.format("M月D日") }}-{{ end.format("M月D日") }}</span>
      <span>
        <i
          v-if="list.every(item => item.status === 2)"
          class="anyteachicon anyteach-success blue"
        />
        <span class="op">
          {{ list.filter(item => item.status === 2).length }}/{{ list.length }}
        </span>
      </span>
    </div>
  </router-link>
</template>
<script>

export default {
  name: "WeekListItem",
  props: ["data", "start", "end", "list"],
  computed: {
    url() {
      const format = "YYYY-MM-DD"
      return `/homework/date?start=${this.start.format(format)}&end=${this.end.format(format)}`
    }
  },
}
</script>
<style scoped lang="scss">
@import "../style.scss";

.week-list-item {
  @include card();
  padding: 13px 5%;
  margin: 0 auto 15px auto;
  &:active {
    opacity: 0.6;
  }
  .op {
    opacity: 0.6;
  }

  .units {
    margin-left: 5px;
  }
  .with {
    margin: 0 7px;
    opacity: 0.6;
  }
  .flex {
    font-size: 0.85rem;
    width: 100%;
  }
  .title {
    font-weight: 500;
  }
  .content-start {
    justify-content: flex-start;
  }
  h4 {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .teacher {
    display: flex;
    align-items: center;
    .img {
      margin-right: 3px;
      $size: 16px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
}
</style>
